import { z } from "zod";
import {
  AddressSchema,
  BankDetailsSchema,
  TaxIdsSchema,
  TenantSchema,
} from "../schemas";
const nullableText = z.string().trim().max(10_000).nullable();
/** Full profile replacement: null clears optional facts, [] clears bank accounts. */
export const OrganizationProfileDataSchema = z
  .object({
    name: TenantSchema.shape.name.max(500),
    legalForm: nullableText,
    address: AddressSchema.extend({
      additionalInfo: nullableText,
      countryCode: AddressSchema.shape.countryCode.regex(/^[A-Z]{2}$/),
    }).strict(),
    taxIds: TaxIdsSchema.extend({
      vatId: TaxIdsSchema.shape.vatId.unwrap().nullable(),
      taxIdLocal: nullableText,
      uid: nullableText,
    }).strict(),
    bankDetails: z.array(BankDetailsSchema.strict()).max(50),
    contactEmail: TenantSchema.shape.contactEmail.unwrap().nullable(),
    phone: nullableText,
    fax: nullableText,
    website: TenantSchema.shape.website.unwrap().nullable(),
    commercialRegisterNumber: nullableText,
    legalInformation: nullableText,
    defaultEInvoiceFormat: TenantSchema.shape.defaultEInvoiceFormat
      .unwrap()
      .nullable(),
  })
  .strict();
// Existing profiles may be incomplete; reads must let the administrator repair them.
export const OrganizationProfileRecordSchema =
  OrganizationProfileDataSchema.extend({
    id: TenantSchema.shape.id,
    updatedAt: z.string().min(1).max(128),
    address: z.object({
      street: nullableText,
      additionalInfo: nullableText,
      postalCode: nullableText,
      city: nullableText,
      countryCode: nullableText,
    }),
    taxIds: z.object({
      vatId: nullableText,
      taxIdLocal: nullableText,
      uid: nullableText,
    }),
    contactEmail: nullableText,
    website: nullableText,
    bankDetails: z
      .array(
        z.object({
          bankName: z.string().optional(),
          iban: z.string(),
          bic: z.string().optional(),
          accountHolder: z.string().optional(),
        }),
      )
      .max(50),
  });
export const OrganizationProfileSaveSchema = z
  .object({
    data: OrganizationProfileDataSchema,
    expectedUpdatedAt: z.string().min(1).max(128),
  })
  .strict();
export type OrganizationProfileData = z.infer<
  typeof OrganizationProfileDataSchema
>;
export type OrganizationProfileRecord = z.infer<
  typeof OrganizationProfileRecordSchema
>;
export type OrganizationProfileSave = z.infer<
  typeof OrganizationProfileSaveSchema
>;
